import { render, staticRenderFns } from "./CotejoDocumentosInfo.vue?vue&type=template&id=6dc5430a"
import script from "./CotejoDocumentosInfo.vue?vue&type=script&lang=js"
export * from "./CotejoDocumentosInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc5430a')) {
      api.createRecord('6dc5430a', component.options)
    } else {
      api.reload('6dc5430a', component.options)
    }
    module.hot.accept("./CotejoDocumentosInfo.vue?vue&type=template&id=6dc5430a", function () {
      api.rerender('6dc5430a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/CotejoDocumentosInfo.vue"
export default component.exports